module.exports = __webpack_public_path__ + "static/img/introduceBTypeAIcon3.8d34f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeAIcon3.png
// module id = tQoe
// module chunks = 0